import { API_REQUEST, GET_PIE_ANALYSIS_CALCULATION } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const getPIEAnalysisCalculation = (profileType: string, snapshotId: string): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/get-pie-analysis-calculation/${profileType}/${snapshotId}`,
    next: GET_PIE_ANALYSIS_CALCULATION,
    method: 'GET',
    authorization: true
  }
});